import { render } from "./CustomerRankingChartList.vue?vue&type=template&id=380d20e7&ts=true"
import script from "./CustomerRankingChartList.vue?vue&type=script&lang=ts"
export * from "./CustomerRankingChartList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__